import { Dropdown, IDropdownOption, IDropdownProps } from "@fluentui/react";
import React from "react";
import { useIntl } from "react-intl";
import { TeamTypeSettingsRequestBy } from "../../../../../../models/enums/TeamTypeSettingsRequestBy";

interface IRequestByDropdownProps {
	selectedKeys: IDropdownProps["selectedKeys"];
	onChange: (option: IDropdownOption) => void;
}

export default function RequestByDropdown(props: IRequestByDropdownProps) {
	const intl = useIntl();

	const requestByOptions = [
		{
			key: TeamTypeSettingsRequestBy.TeamManagers,
			text: "Team managers",
		},
		{
			key: TeamTypeSettingsRequestBy.TeamMembers,
			text: "Team members",
		},
		{
			key: TeamTypeSettingsRequestBy.TeamOwners,
			text: "Team owners",
		},
		{
			key: TeamTypeSettingsRequestBy.TeamContactPersons,
			text: "Team contact persons"
		},
		{
			key: TeamTypeSettingsRequestBy.Archivaris,
			text: "Archivaris"
		},
	];

	return (
		<Dropdown
			required
			className="ilx-text-field-small"
			selectedKeys={props.selectedKeys}
			placeholder={intl.formatMessage({
				id: "settings.teams.newTeam.cannotBeSubmittedByAnyone",
				defaultMessage: "Niemand kan indienen",
			})}
			multiSelect
			options={requestByOptions}
			onChange={(event, option) => {
				if (option) {
					props.onChange(option);
				}
			}}
			style={{ marginTop: "0.75rem" }}
		/>
	);
}